(() => {
  if (window.KarmaBraceletNotes) return;
  const config = JSON.parse(document.getElementById('ks-bracelet-note-config').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const request = window.fetch.bind(window);
  const properties = ['Prelungire gratuită (cm în plus)', 'Free extension (extra cm)'];
  let queue = Promise.resolve();
  let cart = config.cart;
  let customerDraft;
  let checkoutBusy = false;
  const replayClicks = new WeakSet();
  const replayForms = new WeakSet();


  const serviceId = Number(config.serviceId);
  const adjustmentProperty = 'Personalizare brățară';
  function adjustment(item) {
    const raw = item.properties?._ks_adjustment;
    if (!raw) return null;
    const match = /^(shorten|extend):(\d+(?:\.\d{1,2})?)$/.exec(String(raw));
    if (!match || Number(match[2]) <= 0 || (match[1] === 'extend' && Number(match[2]) > 3)) throw new Error(config.error);
    const cm = String(Number(match[2]));
    const mode = match[1];
    return { mode, cm, group: `${item.variant_id || item.id}|${mode}:${cm}`, text: (mode === 'shorten' ? config.shortValue : config.extendValue).replace('{cm}', cm.replace('.', ',')) };
  }
  function isService(item) { return Number(item.variant_id || item.id) === serviceId; }
  function serviceItem(item) {
    const value = adjustment(item);
    if (!value || !serviceId) throw new Error(config.error);
    return { id: serviceId, quantity: Number(item.quantity), properties: {
      _ks_service_for: value.group,
      [config.serviceProduct]: String(item.product_title || item.title || '').replace(/[\r\n]+/g, ' '),
      [config.serviceAdjustment]: value.text
    } };
  }
  function servicePlan(state) {
    const wanted = new Map();
    for (const item of state.items || []) {
      if (isService(item)) continue;
      const value = adjustment(item);
      if (!value || item.quantity < 1) continue;
      if (wanted.has(value.group)) wanted.get(value.group).quantity += Number(item.quantity);
      else wanted.set(value.group, serviceItem(item));
    }
    const updates = {}, assigned = new Set();
    for (const item of state.items || []) {
      if (!isService(item)) continue;
      const key = item.properties?._ks_service_for;
      const quantity = wanted.has(key) && !assigned.has(key) ? wanted.get(key).quantity : 0;
      if (quantity !== item.quantity) updates[item.key] = quantity;
      assigned.add(key);
    }
    return { updates, additions: [...wanted].filter(([key]) => !assigned.has(key)).map(([,item]) => item) };
  }
  async function post(path, body) {
    const response = await request(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const state = await response.json();
    if (!response.ok || state.errors || state.status) throw new Error(state.description || state.message || config.error);
    return state;
  }
  async function syncServices(state) {
    const plan = servicePlan(state);
    if (Object.keys(plan.updates).length) state = await post('cart/update.js', { updates: plan.updates });
    if (plan.additions.length) { await post('cart/add.js', { items: plan.additions }); state = await readCart(); }
    const remaining = servicePlan(state);
    if (Object.keys(remaining.updates).length || remaining.additions.length) throw new Error(config.error);
    return state;
  }
  function removedServiceGroups(state, body, path) {
    if (!body) return [];
    const removed = new Set();
    const mark = (item, quantity) => { if (item && isService(item) && Number(quantity) === 0 && item.properties?._ks_service_for) removed.add(item.properties._ks_service_for); };
    if (/\/change(?:\.js|\.json)?\/?$/.test(path)) {
      const item = body.line ? state.items[Number(body.line)-1] : state.items.find(item => item.key === String(body.id) || String(item.variant_id) === String(body.id));
      mark(item, body.quantity);
    } else if (body.updates) {
      for (const [key, quantity] of Object.entries(body.updates)) {
        const item = Array.isArray(body.updates) ? state.items[Number(key)] : state.items.find(item => item.key === key || String(item.variant_id) === key);
        mark(item,quantity);
      }
    }
    return [...removed];
  }
  async function clearAdjustments(state, groups) {
    for (const group of groups) {
      for (;;) {
        const item = state.items.find(item => !isService(item) && adjustment(item)?.group === group);
        if (!item) break;
        const values = { ...item.properties, _ks_adjustment: '' };
        delete values[adjustmentProperty];
        state = await post('cart/change.js', { id: item.key, quantity: item.quantity, properties: values });
      }
    }
    return state;
  }
  async function requestBody(input, options) {
    let body=options?.body;
    if(body===undefined && input instanceof Request) body=await input.clone().text();
    if(typeof body==='string') { try{return JSON.parse(body);}catch{body=new URLSearchParams(body);} }
    if(body instanceof FormData || body instanceof URLSearchParams) {
      const result={};
      for(const [key,value] of body) {
        const match=/^updates\[(.+)\]$/.exec(key);
        if(match) (result.updates ||= {})[match[1]]=value;
        else result[key]=value;
      }
      return result;
    }
    return null;
  }

  function customerNote(note) {
    return String(note || '')
      .replace(/(?:\r?\n){0,2}\[Prelungiri gratuite KarmaShop\][\s\S]*?\[\/Prelungiri gratuite KarmaShop\]/g, '')
      .split(/\r?\n/)
      .filter(line => !/^.+ — (?:(?:prelungire|extension) \+|scurtare la |shorten to )\d+(?:[.,]\d+)? cm$/.test(line))
      .join('\n').trim();
  }

  function extensionLines(items) {
    const lines = new Map();
    for (const item of items || []) {
      if (isService(item) || item.quantity < 1) continue;
      const product = String(item.product_title || item.title || '').replace(/[\r\n]+/g,' ');
      const value = adjustment(item);
      if (value) {
        lines.set(value.group, config.adjustmentLine.replace('{product}',product).replace('{adjustment}',value.text));
        continue;
      }
      const legacy = properties.map(key=>item.properties?.[key]).find(value=>value!=null && value!=='');
      const cm=String(legacy??'').trim().replace(',','.');
      if(!/^\d+(?:\.\d{1,2})?$/.test(cm) || Number(cm)<=0 || Number(cm)>3) continue;
      lines.set(`${item.variant_id || item.id}|legacy:${Number(cm)}`,config.line.replace('{product}',product).replace('{cm}',String(Number(cm)).replace('.',',')).replace('{quantity}',String(item.quantity)));
    }
    return [...lines.values()];
  }

  function buildNote(state, note = state.note) {
    const original = customerNote(note);
    const lines = extensionLines(state.items);
    return [original, lines.join('\n')].filter(Boolean).join('\n\n');
  }

  function reflect(state) {
    cart = state;
    document.documentElement.dataset.ksExtensionCart = String(extensionLines(state.items).length > 0);
    document.querySelectorAll('textarea[name="note"], input[name="note"]').forEach(input => {
      const value = state.note || '';
      if (input !== document.activeElement && input.value !== value) input.value = value;
    });
    reflectDrawerNote();
  }

  function reflectDrawerNote() {
    const preview = document.querySelector('[data-essential-cart-element="order-note-saved-text"]');
    if (!preview) return;
    const note = buildNote(cart, customerDraft === undefined ? cart.note : customerDraft);
    if (preview.textContent !== note) preview.textContent = note;
  }

  function watchDrawerNote() {
    const portal = document.getElementById('essential-cart-drawer-portal');
    if (!portal) return false;
    new MutationObserver(reflectDrawerNote).observe(portal, { childList: true, subtree: true, characterData: true });
    reflectDrawerNote();
    return true;
  }

  function enqueue(work) {
    const task = queue.catch(() => {}).then(work);
    queue = task;
    return task;
  }

  async function readCart() {
    const response = await request(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(config.error);
    return response.json();
  }

  async function saveNote(state) {
    state = await syncServices(state);
    const note = buildNote(state, customerDraft === undefined ? state.note : customerDraft);
    if (note !== (state.note || '')) {
      const response = await request(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note })
      });
      if (!response.ok) throw new Error(config.error);
      state = await response.json();
      if (state.errors || state.status || state.note !== note) throw new Error(config.error);
    }
    reflect(state);
    return state;
  }

  function ensure() {
    return enqueue(async () => saveNote(await readCart()));
  }

  window.fetch = function(input, options) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
    const method = options?.method || (input instanceof Request ? input.method : 'GET');
    if (url.origin !== location.origin || method.toUpperCase() !== 'POST' || !/\/cart\/(add|change|update|clear)(?:\.js|\.json)?\/?$/.test(url.pathname)) return request(input, options);
    return enqueue(async () => {
      const body=await requestBody(input,options);
      const before = cart.items?.some(isService) && /\/cart\/(change|update)/.test(url.pathname) ? await readCart() : cart;
      const removed=removedServiceGroups(before,body,url.pathname);
      if (/\/cart\/update(?:\.js|\.json)?\/?$/.test(url.pathname) && typeof options?.body === 'string' && body && Object.prototype.hasOwnProperty.call(body,'note') && !body.updates && !body.items) {
        body.note=buildNote(before, customerDraft===undefined ? body.note : customerDraft);
        options={...options,body:JSON.stringify(body)};
      }
      const response=await request(input,options);
      if(!response.ok) return response;
      const payload=await response.clone().json();
      if(payload.errors || payload.status) return response;
      const fullCart=Array.isArray(payload.items) && typeof payload.item_count==='number';
      let state=fullCart?payload:await readCart();
      const originalItems=JSON.stringify(state.items);
      if(removed.length) state=await clearAdjustments(state,removed);
      const saved=await saveNote(state);
      let sections=payload.sections;
      if(JSON.stringify(saved.items)!==originalItems) {
        const keys=sections?Object.keys(sections):(Array.isArray(body?.sections)?body.sections:String(body?.sections||'').split(',').filter(Boolean));
        if(keys.length) {
          const refreshed=await post('cart/update.js',{updates:{},sections:keys,sections_url:body?.sections_url||location.pathname});
          sections=refreshed.sections;
        }
      }
      const result=fullCart?{...payload,...saved}:{...payload};
      if(sections)result.sections=sections;
      const headers=new Headers(response.headers);headers.delete('content-length');headers.delete('content-encoding');
      return new Response(JSON.stringify(result),{status:response.status,statusText:response.statusText,headers});
    });
  };

  document.addEventListener('input', event => {
    if (event.target.matches('textarea[name="note"], input[name="note"], [data-essential-cart-element="order-note-textarea"]')) {
      customerDraft = customerNote(event.target.value);
    }
  });

  async function beforeCheckout(resume) {
    if (checkoutBusy) return;
    checkoutBusy = true;
    try {
      await ensure();
      document.querySelectorAll('[name="note"]').forEach(input => { input.value = cart.note || ''; });
      resume();
    } catch {
      window.alert(config.error);
    } finally {
      checkoutBusy = false;
    }
  }

  document.addEventListener('click', event => {
    const target = event.target.closest('a[href], button, input[type="submit"]');
    if (!target) return;
    if (replayClicks.has(target)) { replayClicks.delete(target); return; }
    const href = target.getAttribute('href');
    const checkoutLink = href && /\/checkout(?:\/|\?|$)/.test(new URL(href, location.href).pathname);
    if (target.name !== 'checkout' && !checkoutLink && !target.matches('[data-essential-cart-checkout]')) return;
    if (target.disabled || event.defaultPrevented) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    beforeCheckout(() => {
      if (target.form) replayForms.add(target.form);
      replayClicks.add(target);
      target.click();
    });
  }, true);

  document.addEventListener('submit', event => {
    if (replayForms.has(event.target)) { replayForms.delete(event.target); return; }
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    beforeCheckout(() => {
      replayForms.add(event.target);
      event.target.requestSubmit(event.submitter);
    });
  }, true);

  document.addEventListener('formdata', event => {
    if (event.formData.has('checkout')) event.formData.set('note', cart.note || '');
  });

  window.KarmaBraceletNotes = { ensure, buildNote, serviceItem };
  reflect(cart);
  if (!watchDrawerNote()) {
    const observer = new MutationObserver(() => { if (watchDrawerNote()) observer.disconnect(); });
    observer.observe(document.body, { childList: true });
  }
  if (cart.items.some(isService) || extensionLines(cart.items).length || customerNote(cart.note) !== String(cart.note || '').trim()) ensure().catch(() => {});
})();

